import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { prepareDate } from 'libs/common';
import { socket } from 'api';
import { deactivateEvent } from 'store/actions/events';
import { Cell, Row, Submit } from './signal.styled';

export const Signal = (props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  // date
  // priority
  // message

  // date
  // source type
  // number
  // priority
  // message

  // date
  // source type + number
  // priority
  // message

  const { view, type } = props;

  const rightConfirm = window.haveRight('mnemo.confirm_events');

  const confirmSignal = () => {
    socket.call('confirm_event_by_id', { id: props.id });
    dispatch(deactivateEvent(props.source, props.id));
  };

  return (
    <Row priority={type}>
      <Cell>{prepareDate(props.timestamp, i18n.language, 'll LTS')}</Cell>
      {(view === 'full' || view === 'full2') && <Cell>{props.source_name}</Cell>}
      <Cell>{props.message}</Cell>
      {(view === 'full2' || view === 'confirm') && (
        <Cell align="right">{rightConfirm ? <Submit onClick={confirmSignal}>{t('buttons.Подтвердить')}</Submit> : <p>-</p>}</Cell>
      )}
    </Row>
  );
};
